import { useBodyClass } from "@/hooks/useBodyClass";
import { useTranslation } from "react-i18next";

export default function Loading({ error = false }) {
    useBodyClass('not-found');
    const { t } = useTranslation();

    return (
        <div className="wrapper has-text-white has-text-centered is-size-3 my-9 py-9">
            {error
                ? t('Ha habido un error')
                : <div className="loader"></div>}

        </div>
    )
}